import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Instagram, Globe, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CONTACTS = [
  { icon: Mail, label: "Email", value: "avatarindustries@gmail.com", href: "mailto:avatarindustries@gmail.com" },
  { icon: Globe, label: "Website", value: "www.avatarwatertanks.in", href: "https://www.avatarwatertanks.in" },
  { icon: Instagram, label: "Social", value: "@avatar.india_", href: "https://instagram.com/avatar.india_" },
];

export const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast.error("Please add your name and email.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/leads`, { type: "contact", ...form });
      toast.success("Thanks for reaching out — we'll be in touch soon.");
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="relative mx-auto max-w-[1400px] px-6 py-24 lg:px-12 lg:py-32">
      <div className="grid grid-cols-1 gap-16 lg:grid-cols-[0.9fr_1.1fr]">
        <Reveal>
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.3em] text-avatar-red">
            (Contact)
          </p>
          <h2 className="font-heading text-4xl font-bold leading-none tracking-tighter text-avatar-ink md:text-6xl">
            Let&apos;s talk<br />water.
          </h2>
          <p className="mt-6 max-w-sm text-base leading-relaxed text-avatar-ink/55">
            Questions about products, pricing or partnerships? Reach the Avatar
            Group team directly.
          </p>

          <div className="mt-12 space-y-2">
            {CONTACTS.map((c) => (
              <a
                key={c.label}
                href={c.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`contact-info-${c.label.toLowerCase()}`}
                className="group flex items-center gap-4 border-t border-avatar-ink/10 py-5 transition-colors duration-300 hover:text-avatar-gold"
              >
                <c.icon size={18} className="text-avatar-gold" />
                <div>
                  <div className="text-xs uppercase tracking-wide text-avatar-ink/40">{c.label}</div>
                  <div className="font-heading text-lg font-semibold text-avatar-ink group-hover:text-avatar-gold">
                    {c.value}
                  </div>
                </div>
              </a>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <form onSubmit={submit} data-testid="contact-form" className="space-y-7">
            <div className="grid grid-cols-1 gap-7 md:grid-cols-2">
              <label className="block">
                <span className="mb-2 block text-xs font-medium uppercase tracking-[0.15em] text-avatar-ink/40">Name</span>
                <input value={form.name} onChange={set("name")} data-testid="contact-name" placeholder="Your name" className="w-full border-b border-avatar-ink/20 bg-transparent py-3 text-avatar-ink outline-none transition-colors duration-300 placeholder:text-avatar-ink/25 focus:border-avatar-red" />
              </label>
              <label className="block">
                <span className="mb-2 block text-xs font-medium uppercase tracking-[0.15em] text-avatar-ink/40">Email</span>
                <input type="email" value={form.email} onChange={set("email")} data-testid="contact-email" placeholder="you@email.com" className="w-full border-b border-avatar-ink/20 bg-transparent py-3 text-avatar-ink outline-none transition-colors duration-300 placeholder:text-avatar-ink/25 focus:border-avatar-red" />
              </label>
            </div>
            <label className="block">
              <span className="mb-2 block text-xs font-medium uppercase tracking-[0.15em] text-avatar-ink/40">Phone</span>
              <input value={form.phone} onChange={set("phone")} data-testid="contact-phone" placeholder="+91" className="w-full border-b border-avatar-ink/20 bg-transparent py-3 text-avatar-ink outline-none transition-colors duration-300 placeholder:text-avatar-ink/25 focus:border-avatar-red" />
            </label>
            <label className="block">
              <span className="mb-2 block text-xs font-medium uppercase tracking-[0.15em] text-avatar-ink/40">Message</span>
              <textarea rows={4} value={form.message} onChange={set("message")} data-testid="contact-message" placeholder="How can we help?" className="w-full resize-none border-b border-avatar-ink/20 bg-transparent py-3 text-avatar-ink outline-none transition-colors duration-300 placeholder:text-avatar-ink/25 focus:border-avatar-red" />
            </label>
            <button
              type="submit"
              disabled={loading}
              data-testid="contact-submit"
              className="group inline-flex items-center gap-2 rounded-full bg-avatar-ink px-8 py-4 text-sm font-semibold text-white transition-colors duration-300 hover:bg-avatar-red disabled:opacity-60"
            >
              {loading ? "Sending..." : "Send Message"}
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </form>
        </Reveal>
      </div>
    </section>
  );
};
